<script lang="ts" setup>
import AdvantageCard from '~/components/cards/AdvantageCard.vue'
import PartnerBox from '~/components/partner/PartnerBox.vue'
import PartnerSubtitle from '~/components/partner/PartnerSubtitle.vue'

const programItems = [
  {
    iconName: 'outlined/nutri',
    title: 'Нутрициологам, health-коучам'
  },
  {
    iconName: 'outlined/doc',
    title: 'Врачам с\xA0превентивным или\xA0интегративным подходом'
  },
  {
    iconName: 'outlined/strength',
    title: 'Врачам с\xA0превентивным или\xA0интегративным подходом'
  },
  {
    iconName: 'outlined/cosmetics',
    title: 'Косметологам'
  },
  {
    iconName: 'outlined/photo',
    title: 'ЗОЖ-блогерам с\xA0аудиторией 10\xA0000+\xA0человек'
  },
]
</script>

<template>
  <PartnerBox class="my-2 flex w-full flex-col md:flex-row md:justify-between">
    <div class="mb-7 md:mb-0 md:w-[calc(50%-16px)]">
      <PartnerSubtitle
        class="!mb-5 md:!mb-8 md:max-w-[90%]"
        subtitle="Получайте клиентов и&nbsp;зарабатывайте на&nbsp;своей экспертности"
      />

      <p class="text-[17px] font-medium leading-[1.27] text-main-silver md:max-w-[90%] md:text-[22px]">
        Платформа для&nbsp;специалистов, которые хотят консультировать, а&nbsp;не&nbsp;заниматься техническими задачами, поиском клиентов и&nbsp;продвижением
      </p>
    </div>

    <div class="md:w-[calc(50%-16px)]">
      <b class="mb-3 block text-lg font-medium leading-[1.08] text-main-dark md:mb-5 md:text-[26px]">
        Программа подойдет
      </b>

      <div class="flex flex-col space-y-2.5 md:space-y-3">
        <AdvantageCard v-for="x in programItems" :key="x.title" :advantage="x" class="!bg-[#F1F1F1]" />
      </div>
    </div>
  </PartnerBox>
</template>
